<div *ngIf="companyProfileSkeletonLoading$ | async">Loading...</div>
<div *ngIf="companyProfileSkeletonLoaded$ | async">
  <mat-accordion *ngIf="companyProfileSkeleton$ | async as companyProfileSkeleton">
    <mat-expansion-panel (opened)="companyProfileOpened(companyProfileSkeleton)">
      <mat-expansion-panel-header> Company Profile </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-company-profile-audit-list
          #companyProfileAuditList
          [companyProfileId]="companyProfileSkeleton.customerId"
          [loading]="companyProfileAuditsLoading$ | async"
          [companyProfileAudits]="companyProfileAudits$ | async"
          (nextPage)="nextCompanyProfileAuditPage($event)"
          (loadCompanyProfile)="loadCompanyProfileAudits($event)"
        >
        </sd-portal-company-profile-audit-list>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Aircraft Type Ratings </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let aircraftTypeRating of companyProfileSkeleton.aircraftTypeRatings"
            (opened)="aircraftTypeRatingOpened(aircraftTypeRating.aircraftTypeRatingId)"
          >
            <mat-expansion-panel-header> {{ aircraftTypeRating.name }} </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-aircraft-type-rating-audit-list
                #aircraftTypeRatingAuditList
                [aircraftTypeRatingId]="aircraftTypeRating.aircraftTypeRatingId"
                [aircraftTypeRatingAudits]="aircraftTypeRatingAudits$ | async"
                [loading]="aircraftTypeRatingAuditsLoading$ | async"
                (nextPage)="nextAircraftTypeRatingAuditPage($event)"
                (loadAircraftTypeRating)="loadAircraftTypeRatingAudits($event)"
              >
              </sd-portal-aircraft-type-rating-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Company Offices </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let companyAddress of companyProfileSkeleton.companyAddresses"
            (opened)="companyAddressOpened(companyAddress.companyAddressId)"
          >
            <mat-expansion-panel-header>
              {{ companyAddress.title }}
              <span *ngIf="companyAddress.isDeleted"
                >{{ companyAddress.companyAddressId }}&nbsp;(Deleted)</span
              >
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-company-address-audit-list
                #companyAddressAuditList
                [companyAddressId]="companyAddress.companyAddressId"
                [loading]="companyAddressAuditsLoading$ | async"
                [companyAddressAudits]="companyAddressAudits$ | async"
                (nextPage)="nextCompanyAddressAuditPage($event)"
                (loadCompanyAddress)="loadCompanyAddressAudits($event)"
              >
              </sd-portal-company-address-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Crew Duty </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let customerDuty of companyProfileSkeleton.customerDuties"
            (opened)="customerDutyOpened(customerDuty.customerDutyId)"
          >
            <mat-expansion-panel-header
              >{{ customerDuty.name }}
              <span *ngIf="customerDuty.isDeleted">&nbsp;(Deleted)</span>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-customer-duty-audit-list
                #customerDutyAuditList
                [loading]="customerDutyAuditsLoading$ | async"
                [customerDutyId]="customerDuty.customerDutyId"
                [customerDutyAudits]="customerDutyAudits$ | async"
                (nextPage)="nextCustomerDutyAuditPage($event)"
                (loadCustomerDuty)="loadCustomerDutyAudits($event)"
              >
              </sd-portal-customer-duty-audit-list>

              <!-- Duty time allowances -->
              <mat-accordion>
                <mat-expansion-panel
                  *ngFor="let dutyTimeAllowance of customerDuty.dutyTimeAllowances"
                  (opened)="dutyTimeAllowanceOpened(dutyTimeAllowance.dutyTimeAllowanceId)"
                >
                  <mat-expansion-panel-header>{{
                    dutyTimeAllowance.tail
                  }}</mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <sd-portal-duty-time-allowance-audit-list
                      #dutyTimeAllowanceAuditList
                      [loading]="dutyTimeAllowanceAuditsLoading$ | async"
                      [dutyTimeAllowanceId]="dutyTimeAllowance.dutyTimeAllowanceId"
                      [dutyTimeAllowanceAudits]="dutyTimeAllowanceAudits$ | async"
                      (nextPage)="nextDutyTimeAllowanceAuditPage($event)"
                      (loadDutyTimeAllowance)="loadDutyTimeAllowanceAudits($event)"
                    >
                    </sd-portal-duty-time-allowance-audit-list>
                  </ng-template>
                </mat-expansion-panel>
              </mat-accordion>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Delay Types </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let delayType of companyProfileSkeleton.delayTypes"
            (opened)="delayTypeOpened(delayType.delayTypeId)"
          >
            <mat-expansion-panel-header>{{ delayType.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-delay-type-audit-list
                #delayTypeAuditList
                [loading]="delayTypeAuditsLoading$ | async"
                [delayTypeId]="delayType.delayTypeId"
                [delayTypeAudits]="delayTypeAudits$ | async"
                (nextPage)="nextDelayTypeAuditPage($event)"
                (loadDelayType)="loadDelayTypeAudits($event)"
              >
              </sd-portal-delay-type-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Departments </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let department of companyProfileSkeleton.departments"
            (opened)="departmentOpened(department.departmentId)"
          >
            <mat-expansion-panel-header>{{ department.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-department-audit-list
                #departmentAuditList
                [loading]="departmentAuditsLoading$ | async"
                [departmentId]="department.departmentId"
                [departmentAudits]="departmentAudits$ | async"
                (nextPage)="nextDepartmentAuditPage($event)"
                (loadDepartment)="loadDepartmentAudits($event)"
              >
              </sd-portal-department-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Duty Time Buffers </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let dutyTimeBuffer of companyProfileSkeleton.dutyTimeBuffers"
            (opened)="dutyTimeBufferOpened(dutyTimeBuffer.dutyTimeBufferId)"
          >
            <mat-expansion-panel-header>{{ dutyTimeBuffer.tail }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-duty-time-buffer-audit-list
                #dutyTimeBufferAuditList
                [loading]="dutyTimeBufferAuditsLoading$ | async"
                [dutyTimeBufferId]="dutyTimeBuffer.dutyTimeBufferId"
                [dutyTimeBufferAudits]="dutyTimeBufferAudits$ | async"
                (nextPage)="nextDutyTimeBufferAuditPage($event)"
                (loadDutyTimeBuffer)="loadDutyTimeBufferAudits($event)"
              >
              </sd-portal-duty-time-buffer-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Expense Types </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let expenseType of companyProfileSkeleton.expenseTypes"
            (opened)="expenseTypeOpened(expenseType.expenseTypeId)"
          >
            <mat-expansion-panel-header>{{ expenseType.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-expense-type-audit-list
                #expenseTypeAuditList
                [loading]="expenseTypeAuditsLoading$ | async"
                [expenseTypeId]="expenseType.expenseTypeId"
                [expenseTypeAudits]="expenseTypeAudits$ | async"
                (nextPage)="nextExpenseTypeAuditPage($event)"
                (loadExpenseType)="loadExpenseTypeAudits($event)"
              >
              </sd-portal-expense-type-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Flight Crew Positions </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let crewMemberType of companyProfileSkeleton.crewMemberTypes"
            (opened)="crewMemberTypeOpened(crewMemberType.crewMemberTypeId)"
          >
            <mat-expansion-panel-header>{{ crewMemberType.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-crew-member-type-audit-list
                #crewMemberTypeAuditList
                [loading]="crewMemberTypeAuditsLoading$ | async"
                [crewMemberTypeId]="crewMemberType.crewMemberTypeId"
                [crewMemberTypeAudits]="crewMemberTypeAudits$ | async"
                (nextPage)="nextCrewMemberTypeAuditPage($event)"
                (loadCrewMemberType)="loadCrewMemberTypeAudits($event)"
              >
              </sd-portal-crew-member-type-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Payment Types </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let paymentType of companyProfileSkeleton.paymentTypes"
            (opened)="paymentTypeOpened(paymentType.paymentTypeId)"
          >
            <mat-expansion-panel-header>{{ paymentType.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-payment-type-audit-list
                #paymentTypeAuditList
                [loading]="paymentTypeAuditsLoading$ | async"
                [paymentTypeId]="paymentType.paymentTypeId"
                [paymentTypeAudits]="paymentTypeAudits$ | async"
                (nextPage)="nextPaymentTypeAuditPage($event)"
                (loadPaymentType)="loadPaymentTypeAudits($event)"
              >
              </sd-portal-payment-type-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Business Categories </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let businessCategory of companyProfileSkeleton.businessCategories"
            (opened)="businessCategoryOpened(businessCategory.businessCategoryId)"
          >
            <mat-expansion-panel-header>{{ businessCategory.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-business-category-audit-list
                #businessCategoryAuditList
                [loading]="businessCategoryAuditsLoading$ | async"
                [businessCategoryId]="businessCategory.businessCategoryId"
                [businessCategoryAudits]="businessCategoryAudits$ | async"
                (nextPage)="nextBusinessCategoryAuditPage($event)"
                (loadBusinessCategory)="loadBusinessCategoryAudits($event)"
              >
              </sd-portal-business-category-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Job Grades </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let jobGrade of companyProfileSkeleton.jobGrades"
            (opened)="jobGradeOpened(jobGrade.jobGradeId)"
          >
            <mat-expansion-panel-header>{{ jobGrade.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-job-grade-audit-list
                #jobGradeAuditList
                [loading]="jobGradeAuditsLoading$ | async"
                [jobGradeId]="jobGrade.jobGradeId"
                [jobGradeAudits]="jobGradeAudits$ | async"
                (nextPage)="nextJobGradeAuditPage($event)"
                (loadJobGrade)="loadJobGradeAudits($event)"
              >
              </sd-portal-job-grade-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Staff Event Types </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let staffEventType of companyProfileSkeleton.staffEventTypes"
            (opened)="staffEventTypeOpened(staffEventType.staffEventTypeId)"
          >
            <mat-expansion-panel-header>{{ staffEventType.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-staff-event-type-audit-list
                #staffEventTypeAuditList
                [loading]="staffEventTypeAuditsLoading$ | async"
                [staffEventTypeId]="staffEventType.staffEventTypeId"
                [staffEventTypeAudits]="staffEventTypeAudits$ | async"
                (nextPage)="nextStaffEventTypeAuditPage($event)"
                (loadStaffEventType)="loadStaffEventTypeAudits($event)"
              >
              </sd-portal-staff-event-type-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header> Staff Groups </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="let staffGroup of companyProfileSkeleton.staffGroups"
            (opened)="staffGroupOpened(staffGroup.staffGroupId)"
          >
            <mat-expansion-panel-header>{{ staffGroup.name }}</mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <sd-portal-staff-group-audit-list
                #staffGroupAuditList
                [loading]="staffGroupAuditsLoading$ | async"
                [staffGroupId]="staffGroup.staffGroupId"
                [staffGroupAudits]="staffGroupAudits$ | async"
                (nextPage)="nextStaffGroupAuditPage($event)"
                (loadStaffGroup)="loadStaffGroupAudits($event)"
              >
              </sd-portal-staff-group-audit-list>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
